// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as TriggerDownload from "../../primitives/TriggerDownload.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as StockTransferSheet from "./StockTransferSheet.res.js";

function StockTransferTableRowActions(props) {
  let onError = props.onError;
  let code = props.code;
  let id = props.id;
  let match = React.useState(() => false);
  let setCsvDownloadRequested = match[1];
  let csvDownloadRequested = match[0];
  let match$1 = React.useState(() => false);
  let setExcelDownloadRequested = match$1[1];
  let excelDownloadRequested = match$1[0];
  let processBlobAndOpenFile = (future, filename) => Future.tap(Future.flatMap(future, undefined, result => {
    if (result.TAG === "Ok") {
      return TriggerDownload.fromBlob(result._0, filename);
    } else {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    }
  }), result => {
    setCsvDownloadRequested(param => false);
    if (result.TAG === "Ok") {
      return;
    } else {
      return onError("Something went wrong");
    }
  });
  React.useEffect(() => {
    if (!csvDownloadRequested) {
      return;
    }
    let filename = StockTransferSheet.makeCsvFilename(code);
    let future = processBlobAndOpenFile(StockTransferSheet.queryAndMakeCsvBlob(id), filename);
    return () => Future.cancel(future);
  }, [csvDownloadRequested]);
  React.useEffect(() => {
    if (!excelDownloadRequested) {
      return;
    }
    let filename = StockTransferSheet.makeExcelFilename(code);
    let future = processBlobAndOpenFile(StockTransferSheet.queryAndMakeExcelBlob(id), filename);
    return () => Future.cancel(future);
  }, [excelDownloadRequested]);
  return JsxRuntime.jsx(MenuActions.make, {
    children: JsxRuntime.jsxs(MenuActions.Section.make, {
      children: [
        JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("Download CSV"),
          icon: "csv_see",
          onAction: () => setCsvDownloadRequested(param => true)
        }),
        JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("Download Excel"),
          icon: "excel_see",
          onAction: () => setExcelDownloadRequested(param => true)
        })
      ]
    }),
    trigger: {
      TAG: "Compact",
      icon: "more_v2",
      size: "small",
      bold: true
    }
  });
}

let make = React.memo(StockTransferTableRowActions);

export {
  make,
}
/* make Not a pure module */
